import { createSlice } from "@reduxjs/toolkit";

export const buyerAuthSlice = createSlice({
  name: "buyerAuth",
  initialState: {
    user: null,
    accessToken: null,
    accessType: null,
    loginDate: null,
    redirectUrl: null,
  },

  reducers: {
    setBuyerUser: (state, action) => {
      state.user = action.payload;
    },

    setBuyerTokens: (state, action) => {
      state.accessToken = action.payload.access_token;
    },

    setBuyerAccessType: (state, action) => {
      state.accessType = action.payload.access_type;
    },

    setBuyerLoginDate: (state, action) => {
      state.loginDate = action.payload.loginDate;
    },

    setBuyerRedirectUrl: (state, action) => {
      state.redirectUrl = action.payload;
    },

    clearBuyerRedirectUrl: (state) => {
      state.redirectUrl = null;
    },

    clearBuyerAuth: (state) => {
      state.user = null;
      state.accessToken = null;
      state.loginDate = null;
      state.redirectUrl = null;
      state.accessType = null;
    },
  },
});

export const {
  setBuyerUser,
  setBuyerTokens,
  setBuyerAccessType,
  setBuyerLoginDate,
  setBuyerRedirectUrl,
  clearBuyerRedirectUrl,
  clearBuyerAuth,
} = buyerAuthSlice.actions;

export default buyerAuthSlice.reducer;
